export type IntegerRandom = (exclusiveMaximum: number) => number;

export const economyRandom: IntegerRandom = maximum => {
  if (!Number.isSafeInteger(maximum) || maximum < 1 || maximum > 0x1_0000_0000) throw new RangeError('Invalid random range');
  const limit = Math.floor(0x1_0000_0000 / maximum) * maximum;
  const buffer = new Uint32Array(1);
  do { crypto.getRandomValues(buffer); } while (buffer[0]! >= limit);
  return buffer[0]! % maximum;
};
